/* custom-cl-atc.js — SHARED delegated add-to-cart handler (REBUILD-SPEC M10a).
   Contract: any <form data-cl-atc-form action="/cart/add"> with input[name=id].
   Selling plan resolution order: checked input[name="cl-offer"]'s data-plan inside the form,
   else the form's input[name=selling_plan] value, else none.
   POSTs FormData to /cart/add.js (we own the payload — Seal otherwise overwrites the
   hidden selling_plan input), fires cl:cart-added, opens UpCart if present, else
   navigates to /cart (the rebuilt cart page is the no-app surface). Falls back to native
   submit WITH the plan restored by name. Required on every ATC surface (P1/P6/P13/cart). */
(function () {
  if (window.__clAtcBound) return;
  window.__clAtcBound = true;

  /* Locale root: '/' on bg, '/en/' on the EN subfolder. Shopify injects Shopify.routes.root
     through content_for_header, so it is present on every storefront page. Root-relative
     literals ('/cart') do NOT carry the locale prefix and would bounce EN shoppers onto the
     Bulgarian cart. Always returns a value ending in '/'; falls back to '/' (today's behaviour)
     if Shopify or routes is undefined. */
  function clRoot() {
    var r;
    try {
      r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    } catch (x) { r = null; }
    if (typeof r !== 'string' || !r) r = '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }

  /* Analytics: Shopify's storefront counts a submit on any form whose action contains /cart/add as an
     AddToCart (no value, and it fires even when the add then fails) and then counts our own
     /cart/add.js call as a second one — two AddToCart per click in Meta, different event ids, no
     dedup (traced 2026-10-01, tools/lp/pixel-trace.mjs). JS owns these forms, so the action is parked
     in data-cl-action and put back only for the native fallback. */
  function clDetach(form) {
    var a = form.getAttribute('action');
    if (a) { form.setAttribute('data-cl-action', a); form.removeAttribute('action'); }
  }
  function clRestore(form) {
    var a = form.getAttribute('data-cl-action');
    if (a && !form.getAttribute('action')) form.setAttribute('action', a);
  }
  function clDetachAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('form[data-cl-atc-form]'), clDetach);
  }
  clDetachAll();
  try {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('form[data-cl-atc-form]')) clDetach(n);
          if (n.querySelectorAll) clDetachAll(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (x) {}

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-cl-atc-form]');
    if (!form) return;
    e.preventDefault();

    var idi = form.querySelector('input[name="id"]');
    var variant = idi ? idi.value : '';
    if (!variant) { clRestore(form); form.submit(); return; }

    var plan = '';
    var sel = form.querySelector('input[name="cl-offer"]:checked');
    if (sel) plan = sel.getAttribute('data-plan') || '';
    else {
      var pi0 = form.querySelector('input[name="selling_plan"]');
      if (pi0) plan = pi0.value || '';
    }

    var qtyInput = form.querySelector('[name="quantity"]'); // matches input OR select (qty control)
    var qty = qtyInput ? (qtyInput.value || '1') : '1';

    var btns = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    document.querySelectorAll('[form="' + form.id + '"]').forEach(function (b) { btns.push(b); });
    /* Pending label comes from the drawer root (the strings carrier), queried ONCE outside the
       loop. The English literal is a last-resort fallback only — it may not flash on bg. */
    var pendingEl = document.querySelector('[data-atc-pending]');
    var pending = (pendingEl && pendingEl.getAttribute('data-atc-pending')) || 'Adding…';
    btns.forEach(function (b) { if (b) { b.dataset.lbl = b.textContent; b.disabled = true; b.textContent = pending; } });

    var fd = new FormData();
    fd.append('id', variant); fd.append('quantity', qty);
    if (plan) fd.append('selling_plan', plan);

    fetch(clRoot() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (line) {
        /* first-subscription offer (bundle): arm the START30 code so checkout applies −€30/set.
           Shown as already applied on the PDP; invalid uses (repeat customer, one-time) are
           simply dropped by checkout. */
        try {
          if (plan && line && line.handle === 'bundle-optimal-methylation') {
            return fetch(clRoot() + 'discount/START30').catch(function () {}).then(function () { return line; });
          }
        } catch (x) {}
        return line;
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cl:cart-added', { bubbles: true }));
        var opened = false;
        try { if (window.upcart && window.upcart.openCart) { window.upcart.openCart(); opened = true; } } catch (x) {}
        if (!opened) window.location.href = clRoot() + 'cart';
      })
      .catch(function () {
        var pi = form.querySelector('input[name="selling_plan"]');
        if (pi) pi.value = plan;
        clRestore(form);
        form.submit();
      })
      .finally(function () { btns.forEach(function (b) { if (b && b.dataset.lbl) { b.disabled = false; b.textContent = b.dataset.lbl; } }); });
  });
})();
